import React from 'react';
import { FormattedMessage } from 'react-intl';

import {
  HorizontalLines,
  CenterHorizontalLines,
  SpaceButton,
  VerticalLines,
  SpaceViewButtonCopy,
} from './spaceViewButton.styles';

export const SPACE_VIEW_BUTTON_TEST_ID = 'spaceViewButtonTestId';

export interface SpaceViewButtonProps {
  handleClick: () => void;
}

export const SpaceViewButton = ({ handleClick }: SpaceViewButtonProps) => (
  <SpaceButton onClick={handleClick} data-testid={SPACE_VIEW_BUTTON_TEST_ID}>
    <CenterHorizontalLines />
    <HorizontalLines />
    <VerticalLines />
    <SpaceViewButtonCopy>
      <div>
        <FormattedMessage id="spaceViewButton.preview" defaultMessage="Preview" />
      </div>
      <div>
        <FormattedMessage id="spaceViewButton.space" defaultMessage="in Your Space" />
      </div>
    </SpaceViewButtonCopy>
  </SpaceButton>
);
